import React, { useEffect, useState } from 'react'
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Grid,
    Select,
    MenuItem,
    DialogActions,
    Button,
    Switch
} from '@material-ui/core';
import { useDispatch } from 'react-redux';

import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";

import translation from "../../../i18n/i18.json";
import AllActions from '../../../actions';
import { ApprovalLevel } from '../../../models/Master/ApprovalLevel';
import { FormError } from '../../../models/FormValidation/FormError';
import { FormFieldMeta } from '../../../models/FormValidation/FormFieldMeta';
import { Role } from '../../../models/Master/Role';
import { RoleName } from '../../../models/Master/RoleName';
import { MasterMetaDataService } from '../../../services/MasterMetaDataService';
import useStyles from "../MasterData.css"
import { MasterDataUtil } from '../../../utils/masterData/MasterDataUtil';
import { MasterDataService } from '../../../services/MasterDataService';
import { InforDisplyaDuration } from '../../../constants/AppConstants';

interface RoleAddDialogProps {
    open: boolean;
    handleClose: any;
    dataObj: Role;
    setDataObj: any;
}

export default function RoleAddDialog(props: RoleAddDialogProps) {
    const initialState: Role = {
        id: 0,
        approvalLevel: "",
        roleName: "",
        isActive: true,
        isSBULevel: false
    }
    
    const classes = useStyles();
    const dispatch = useDispatch();
    const { open, handleClose, dataObj, setDataObj } = props;

    const [formErrors, setFormErrors] = useState<FormError[]>([]);
    const [fistSubmitDone, setFistSubmitDone] = useState(false);
    const validateFieldsData: Array<FormFieldMeta> = [
        { fieldName: "roleName", isRequired: true, reuiredMsg: "Role Name isrequired" },
        { fieldName: "approvalLevel", isRequired: true, reuiredMsg: "Approval Level is required" },
        { fieldName: "isSBULevel", isRequired: false, reuiredMsg: "" }
    ];

    const [roleNameList, setRoleNameList] = useState<RoleName[]>([]);
    const [approvalLevelList, setApprovalLevelList] = useState<ApprovalLevel[]>([]);

    useEffect(() => {
        if (open) {
            prepareForRequest();
            MasterMetaDataService.getRoleNames(
                function (roles: Array<RoleName>) {
                    setRoleNameList(roles);
                    compeleteRequest(true);
                },
                function (error: Error) {
                    setRoleNameList([]);
                    compeleteRequest(false);
                }
            );

            MasterMetaDataService.getApprovalLevels(
                function (approvalLevels: Array<ApprovalLevel>) {
                    setApprovalLevelList(approvalLevels);
                    compeleteRequest(true);
                },
                function (error: Error) {
                    setRoleNameList([]);
                    compeleteRequest(false);
                }
            );
        }
    }, [open])

    const prepareForRequest = () => {
        dispatch(AllActions.backDropActions.openBackDrop());
    };


    const compeleteRequest = (success: boolean, message?: string) => {
        dispatch(AllActions.backDropActions.closeBackDrop());
        if (message) {
            if (success) {
                dispatch(AllActions.infoActions.openInforSuccess(message, InforDisplyaDuration.common));
            } else {
                dispatch(AllActions.infoActions.openInforError(message, InforDisplyaDuration.common));
            }
        }
    };

    const handleChange = (input: string) => (e: any) => {
        setDataObj({
            ...dataObj,
            [input]: e.target.value
        });

    };

    const handleSaveAddNew = (e: any) => {
        setFistSubmitDone(true);
        if (validateData()) {
            saveObject(function (status: boolean) {
                setDataObj(initialState);
            });
        }
    };

    const handleSaveExit = (e: any) => {
        setFistSubmitDone(true);
        if (validateData()) {
            saveObject(function (status: boolean) {
                //setOpen(false);
                handleClose();
            });
        }
    };

    const handleExit = () => {
        setDataObj(initialState);
        setFormErrors([]);
        setFistSubmitDone(false);
    }

    const getErrorState = (input: string) => {
        return MasterDataUtil.getErrorState(input, formErrors);
    };

    const validateData = () => {
        let vailidity = MasterDataUtil.validateData(validateFieldsData, dataObj);
        if (vailidity.isValid) {
            setFormErrors([]);
        }
        else {
            setFormErrors(vailidity.errorsList);
        }
        return vailidity.isValid;
    };

    const saveObject = (onSaveCallback: (status: boolean) => void) => {
        prepareForRequest();
        MasterDataService.saveRole(
            dataObj,
            function (role: Role) {
                if (dataObj.id === 0) {
                    compeleteRequest(true, translation.master_user_dialog_save_suc);
                }
                else {
                    compeleteRequest(true, translation.master_user_dialog_update_suc);
                }
                onSaveCallback(true);
            },
            function (error: Error) {
                compeleteRequest(false, translation.master_add_dialog_save_error);
                onSaveCallback(false);
            }
        );
    };

    return (
        <div className={classes.popUpOuter}>
            <Dialog
                open={open}
                onClose={handleClose}
                onExit={handleExit}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle className={classes.popUpHeader} id="alert-dialog-title">{translation.master_user_dialog_title}</DialogTitle>
                <DialogContent className={classes.NoPopWrapper} >
                    <div>
                        <Grid container spacing={2} item xs={12} sm={12} md={12} lg={12}>
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                <Grid item xs={12} sm={12} md={4} lg={4}>
                                    <span className={classes.createLbl}>
                                        {translation.master_role_name}
                                    </span>
                                </Grid>
                                <Grid className={classes.inputWrapper_Req}>
                                    <Select
                                        variant="outlined"
                                        value={dataObj.approvalLevel || ""}
                                        error={getErrorState("roleName")}
                                        onChange={handleChange("roleName")}
                                    >
                                        {roleNameList.map((obj, index) => (
                                            <MenuItem key={obj.code} value={obj.code}>
                                                {obj.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                <Grid item xs={12} sm={12} md={4} lg={4}>
                                    <span className={classes.createLbl}>
                                        {translation.master_role_approval_level}
                                    </span>
                                </Grid>
                                <Grid className={classes.inputWrapper_Req}>
                                    <Select
                                        variant="outlined"
                                        value={dataObj.approvalLevel || ""}
                                        error={getErrorState("approvalLevel")}
                                        onChange={handleChange("approvalLevel")}
                                    >
                                        {approvalLevelList.map((obj, index) => (
                                            <MenuItem key={obj.id} value={obj.id}>
                                                {obj.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                <Grid item xs={12} sm={12} md={4} lg={4} style={{width: "100px"}}>
                                    <span className={classes.createLbl}>
                                        {translation.master_role_is_sbu_level}
                                    </span>
                                </Grid>
                                <Grid className={classes.inputWrapper_Req}  style={{margin: "0", float:"left", width:"0",}}>
                                    <Switch
                                        checked={dataObj.isSBULevel}
                                        onChange={handleChange("isActive")}
                                    ></Switch>
                                </Grid>
                            </Grid>
                        </Grid>

                    </div>
                </DialogContent>
                <DialogActions>
                    <div style={{ margin: "20px ​10px 15px 0" }}>
                        <div className={classes.greenBtnWrapper}>
                            <Button onClick={handleSaveAddNew} color="primary">
                                <CheckCircleIcon></CheckCircleIcon>
                                {translation.master_add_dialog_save_add_btntxt}
                            </Button>
                        </div>
                        <div className={classes.greenBtnWrapper}>
                            <Button onClick={handleSaveExit} color="primary">
                                <CheckCircleIcon></CheckCircleIcon>
                                {translation.master_add_dialog_save_exit_btntxt}
                            </Button>
                        </div>
                        <div className={classes.grayBtnWrapper}>
                            <Button onClick={handleClose} color="primary" autoFocus>
                                {translation.master_add_dialog_cancelbtntxt}
                            </Button>
                        </div>
                    </div>
                </DialogActions>
            </Dialog>
        </div>
    )
}